import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { LogService } from '../log/log.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class DashboardRedirectGuard implements CanActivate {

  constructor(private router: Router,
              private authStore: AuthenticationStore,
              private logService: LogService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  Observable<boolean> | Promise<boolean> | boolean {
    const gpWindow = (window as any);
    if (this.authStore.hasPermission('ViewDashboard')) {
      if (gpWindow.configGroupPay && gpWindow.configGroupPay.showAgencyDashboard && this.authStore.isAgencyUser()) {
        this.router.navigate([ '/dashboard-agency' ]);
        return false;
      }
      return true;
    } else {
      this.logService.debug('Redirecting to /events since user has no permission to see Dashboard');
      this.router.navigate([ '/events' ]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/dashboard-redirect-guard.ts